import axios from 'axios'

export default{

    getEvents(lat, lng, radius, start, end, limit, state, token) {
      var config = {
        headers: {
          'authorizationToken': token
        },
        params: {
          lat: lat,
          lng: lng,
          radius: radius,
          start: start,
          end: end,
          limit: limit
        },
    }
    if (typeof state !== "undefined" && (typeof state !== "object" || !state)){
      config.params.state = state;
    }else{

    }

      return axios.get('https://api.crowdify.io/v2/events/',config)
      .then((response) => {
        console.log (response)
        console.log("in response: "+response.status)
        if (response.status == 403){

        }
        return response.data;
      }, (error) => {
        console.log("in response error: "+response.status)
        console.log(error);
      });
    },


    getNextPage(nextToken, limit, authorizationToken) {
      let config = {
        headers: {
          'authorizationToken': authorizationToken
        },
        params: {
          next_token: nextToken,
          limit:limit
        },
      }
      return axios.get('https://api.crowdify.io/v2/events/',config)
      .then((response) => {


        return response.data;
      }, (error) => {
        console.log(error);
      });
    },
    getPreviousPage(previousToken, limit, authorizationToken) {
      let config = {
        headers: {
          'authorizationToken': authorizationToken
        },
        params: {
          previous_token: previousToken,
          limit:limit
        },
      }
      return axios.get('https://api.crowdify.io/v2/events/',config)
      .then((response) => {


        return response.data;
      }, (error) => {
        console.log ("in error getEventsByToken")
        console.log(error);
      });
    },

    sendMail(msg){
      const promise = axios.post('https://bqgpab01q9.execute-api.eu-central-1.amazonaws.com/dev',msg)

      return promise
        .then(result => { return result; })
        .catch(error => { return Promise.reject(error); });

    },



}
